var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-card',[_c('b-button',{staticClass:"mb-2",attrs:{"variant":"primary"},on:{"click":_vm.downloadBaseFile}},[_vm._v(" Baixar Modelo ")]),_c('import-file-form',{on:{"imported-file":_vm.importFile}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }